import HashFactory from 'imurmurhash';
import { WebSearchCriteria } from '../../../services/dtos';

const hashFactory = HashFactory();

export function getWebSearchCriteriaChecksum(webSearchCriteria: Partial<WebSearchCriteria>): number {
  try {
    const searchCriteriaValues = {
      placeType: webSearchCriteria.place?.type,
      placeName: webSearchCriteria.place?.name,
      parentPlaceType: webSearchCriteria.place?.parent?.type,
      parentPlaceName: webSearchCriteria.place?.parent?.name,
      minSize: webSearchCriteria.minSize,
      maxSize: webSearchCriteria.maxSize,
      minPrice: webSearchCriteria.minPrice,
      maxPrice: webSearchCriteria.maxPrice,
    };
    return hashFactory.hash(JSON.stringify(searchCriteriaValues)).result();
  } finally {
    hashFactory.reset();
  }
}
